import { type EventSession } from "features/Events/types";
import { useCallback, useEffect, useState } from "react";

const getAvailableSessionRegistrations = (limit: number, current: number) => {
  const delta = limit - current;
  return delta < 0 ? 0 : delta;
};

export const useSessionRegistrationLimits = (session: EventSession, limitEventRegistrationEnabled: boolean) => {
  const [registeredCount, setRegisteredCount] = useState<number>(0);

  useEffect(() => {
    setRegisteredCount(session.userRegistrationCount ?? 0);
  }, [session.userRegistrationCount]);

  const registrationDisabled =
    limitEventRegistrationEnabled &&
    session.registrationLimit != null &&
    registeredCount >= session.registrationLimit &&
    !session.wasRegistered;

  const sessionRegistrationInfo =
    session.registrationLimit && session.registrationLimit > 0
      ? `${getAvailableSessionRegistrations(session.registrationLimit, registeredCount)} / ${session.registrationLimit} available`
      : "";

  const incrementRegistrationCount = useCallback(() => {
    setRegisteredCount(prev => prev + 1);
  }, []);

  const decrementRegistrationCount = useCallback(() => {
    setRegisteredCount(prev => Math.max(prev - 1, 0));
  }, []);

  return { registrationDisabled, sessionRegistrationInfo, incrementRegistrationCount, decrementRegistrationCount };
};
